import {closeCurrentDialog} from 'platform/components';

import {
  useInvalidateBusinessCaseBuyingOnlineOfferMutation,
  useInvalidateBusinessCaseOnlineOfferMutation,
} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {handleApiError} from '../../utils/handleApiError';
import {DestroyDialog} from '../DestroyDialog/DestroyDialog';

interface InvalidateOnlineOfferDialogProps {
  offerId: string;
  onlineOfferKind?: 'BUYING';
}

export function InvalidateOnlineOfferDialog(props: InvalidateOnlineOfferDialogProps) {
  const [invalidateOnlineOffer, {isLoading: isInvalidatingOnlineOffer}] =
    useInvalidateBusinessCaseOnlineOfferMutation();
  const [invalidateBuyingOnlineOffer, {isLoading: isInvalidatingBuyingOnlineOffer}] =
    useInvalidateBusinessCaseBuyingOnlineOfferMutation();
  const isBuyingOffer = props.onlineOfferKind === 'BUYING';
  const invalidateOffer = isBuyingOffer ? invalidateBuyingOnlineOffer : invalidateOnlineOffer;
  const isInvalidatingOffer = isBuyingOffer
    ? isInvalidatingBuyingOnlineOffer
    : isInvalidatingOnlineOffer;

  return (
    <DestroyDialog
      iconPath="alert_icon/circle"
      heading={i18n.t('entity.invalidateOnlineOfferDialog.heading')}
      description={i18n.t('entity.invalidateOnlineOfferDialog.description')}
      isLoading={isInvalidatingOffer}
      onSubmitButtonTitle={i18n.t('entity.invalidateOnlineOfferDialog.confirm')}
      cancelButtonTitle={i18n.t('general.actions.back')}
      onSubmit={() => {
        invalidateOffer({offerId: props.offerId})
          .unwrap()
          .then(closeCurrentDialog)
          .catch(handleApiError);
      }}
    />
  );
}
